import React from 'react';
import './ScrollingText.css';

const ScrollingText = () => {
	return (
		<div className="scrolling-text-container">
			<div className="scrolling-text">
				{/* Add scrolling text content here */}
				<span>Full Derby Results Below! </span>
			</div>
		</div>
	);
};

export default ScrollingText;
